// The Archive panel unmounts whenever the student switches back to "Your tasks", so its
// state would be lost on every tab switch. This module-level cache keeps the first page
// of each filter (and the per-kind counts) for the session: reopening the tab renders
// instantly from it while a fresh copy is fetched in the background.
//
// Only the first page is cached on purpose - it is what the student sees first, and
// revalidating it always replaces it wholesale, so there is nothing to reconcile.

const pages = new Map()
const counts = new Map()

const pageKey = (userId, filter) => `${userId}:${filter}`

export function readFirstPage(userId, filter) {
    return pages.get(pageKey(userId, filter)) || null
}

export function writeFirstPage(userId, filter, page) {
    pages.set(pageKey(userId, filter), page)
}

export function readCounts(userId) {
    return counts.get(userId) || null
}

export function writeCounts(userId, value) {
    counts.set(userId, value)
}
